import React, { useEffect } from 'react';
import WorkShopViewDetails from '../../common/workshop/WorkShopViewDetails';
import { useLocation } from 'react-router-dom';
import CoachLayout from '../../../layouts/CoachLayout';
import MenuLayout from '../../../layouts/MenuLayout';
import CoachMenuLayout from '../../../layouts/CoachMenuLayout';
import { fetchWorkshopeDetailsById } from '../../../redux/features/coach/actions/coachAction';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import Loader from '../../../components/loader';

const WorkshopDetailsPage = () => {
    const { state } = useLocation();
    const dispatch = useDispatch();
    const user = { name: "Workshop", role: "coach" };
    const { isLoading2, workshopDetail } = useSelector((state) => state.coach.coach);
    const location = window?.location?.search?.split("=")[1];
    const [workShopData, setWorkShopData] = useState({
        data: {}
    });

    useEffect(() => {
        let data =
            workshopDetail && Object.keys(workshopDetail).length > 0
                ? workshopDetail
                : state?.data;
        setWorkShopData(prev => ({
            ...prev,
            data: data
        }));
    }, [workshopDetail]);

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(fetchWorkshopeDetailsById({ payload: location }));
    }, []);

    if (isLoading2) {
        return <Loader />
    };
    return (
        <CoachMenuLayout user={user}>
            <WorkShopViewDetails state={workShopData} />
        </CoachMenuLayout>
    )
};

export default WorkshopDetailsPage;